<p class="form-control-label validation-group-label">{{ label }}</p>
@if (subLabel) {
	<p class="form-control-label sub">{{ subLabel }}</p>
}
<div class="rounded-border-box">
	@for (formControl of formArray.controls; track formControl; let index = $index) {
		<app-checkbox hideBorderBox [readOnly]="readOnly" [label]="items[index]" [formControl]="formControl" (click)="controlClicked()">
		</app-checkbox>
	}
</div>